export default "__VITE_ASSET__C$Y_MegV__"